import { msg } from '@lingui/core/macro'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { titleFor } from '~/lib/route-title'
import { decodeTemplatesSearch, type TemplatesSearch } from '~/lib/templates-search'

export const Route = createFileRoute('/_authenticated/$workspaceSlug/templates')({
  component: TemplatesLayout,
  head: () => ({ meta: [{ title: titleFor(msg`Templates`) }] }),
  // The open branch and the open model both live in the URL, so the tab strip
  // and the grid can never disagree, and a model someone found is a link.
  validateSearch: (search: Record<string, unknown>): TemplatesSearch =>
    decodeTemplatesSearch(search),
})

function TemplatesLayout() {
  return <Outlet />
}
